// extracted by mini-css-extract-plugin
export default {"otherSpinnersContainer":"spinner_otherSpinnersContainer__PQLZE","lds-spinner":"spinner_lds-spinner__dVeRm"};